import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "BrightnessContrast"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M11.25 1.5H12.75V3.75H11.25V1.5ZM20.25 11.25H22.5V12.75H20.25V11.25ZM11.25 20.25H12.75V22.5H11.25V20.25ZM1.5 11.25H3.75V12.75H1.5V11.25ZM4.08745 5.16226L5.14795 4.10251L6.73945 5.69251L5.67745 6.75301L4.08745 5.16226ZM17.25 5.68574L18.84 4.09499L19.9005 5.15549L18.3097 6.74699L17.25 5.68574ZM17.2515 18.312L18.312 17.2515L19.9035 18.843L18.843 19.9035L17.2515 18.312ZM4.10257 18.8475L5.69257 17.25L6.75007 18.315L5.16007 19.905L4.10257 18.8475ZM12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18C15.3137 18 18 15.3137 18 12C18 8.68629 15.3137 6 12 6ZM12 16.5C9.51472 16.5 7.5 14.4853 7.5 12C7.5 9.51472 9.51472 7.5 12 7.5V16.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/BrightnessContrast.vue"]]);
